import { render, staticRenderFns } from "./BTFooter.vue?vue&type=template&id=7c55f658&scoped=true&"
import script from "./BTFooter.vue?vue&type=script&lang=js&"
export * from "./BTFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c55f658",
  null
  
)

export default component.exports